import React, { useState, useEffect } from "react";
import { trivvyFileTypeCheck, uploadPreview } from "../../../utils/constants";
import {
  BiCopy,
  BiLogoGoogle,
  BiLogoLinkedin,
  BiLogoMicrosoft,
  BiLogoMicrosoftTeams,
  BiLogoSlack,
  BiLogoWhatsapp,
  BiMailSend,
} from "react-icons/bi";
import * as actionCreators from "../../../modules/actions";
import { connect } from "react-redux";

import ReactTooltip from "react-tooltip";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Popover,
  PopoverHeader,
  PopoverBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Label,
} from "reactstrap";
import SlackSharePopup from "../../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../../components/SlackAndTeamsPopups/TeamsSharePopup";
import { baseUrl } from "../../../utils/constants";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select/lib/Select";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import { data } from "jquery";
import {
  minPlanLimitCheck,
  TRIVIA_LIB_PRIVACY_OPTIONS,
  TRIVVY_LANGUAGES,
} from "../data";
import CheckBox from "rc-checkbox";
import withLoading from "../../../hoc/Loading/Loading";
import moment from "moment";
import SupportedLanguagesText from "../../../components/Trivvy/SupportedLanguagesText";

function UploadLibraryModal({
  open,
  onClose,
  onUploadSuccess,
  isToolkit = true,
  user,
  setCreateLibraryLoader,
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [privacy, setPrivacy] = useState("PRIVATE");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [webUrl, setWebUrl] = useState("");
  const [text, setText] = useState("");
  const [librarySourceType, setLibrarySourceType] = useState(1);
  const [name, setName] = useState("");
  const [isGenerateSummary, setIsGenerateSummary] = useState(false);
  const [alsoTranslate, setAlsoTranslate] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const trivvyPlanType =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType;

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
        };
      } else if (e) {
        let name =
        e.firstName && e.firstName.length > 0 ? e.firstName : e.lastName && e.lastName.length > 0 ? e.lastName : e.email
        return { label: `${name}`, value: e._id || e.userId, permissions: 0 };
      }
    });

    return d;
  };

  const validate = () => {
    if (privacy && uploadedFile && uploadedFile.file) {
      if (
        !uploadedFile.file.type.indexOf("csv") >= 0 &&
        (uploadedFile.file.type.indexOf("pdf") >= 0 ||
          uploadedFile.file.type.indexOf("word") >= 0 ||
          uploadedFile.file.type.indexOf("text") >= 0)
      ) {
        return true;
      } else {
        toastContainer("Please upload WORD/PDF/TEXT files.", "error");

        return false;
      }
    } else {
      return false;
    }
  };

  const getUserList = () => {
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersData(response.data.data);
        const users = formatSelectedUsers(response.data.data);

        setUsersList(users);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserList();
  }, []);

  const fileSelectedHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (trivvyFileTypeCheck(file.type)) {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          datetime: Date.now().toString(),
          // blob: URL.createObjectURL(file),
          preview: URL.createObjectURL(file),
        };
        setUploadedFile(uploadPreview(obj));
      } else {
        toastContainer("Please upload Pdf or Doc or Txt file.", "error");
      }
    }
  };

  const handleOptionChange = (val) => {
    setPrivacy(val.value);
  };

  const renderUploadPreview = () => {
    let photo = uploadedFile;
    let { preview, size } = photo;
    preview = preview != null && preview != undefined ? preview : photo.url;
    let mb = 1024 * 1024;
    let file_size =
      size >= mb
        ? `${(size / mb).toFixed(2)}mb`
        : `${(size / 1024).toFixed(2)}kb`;
    return (
      <span
        className={
          photo.isAccepted == false
            ? "taskUploadPreviewImg rejectedFilesContainer"
            : "taskUploadPreviewImg"
        }
      >
        <img src={preview} className="fileUploadSize" />

        <span
          onClick={() => setUploadedFile(null)}
          className="removeTaskUpload"
        >
          <span className="flaticon-trash" />
        </span>
        <div className="previewTaskImageText">
          <span className="">{photo.name}</span>
        </div>
      </span>
    );
  };

  const callApiToSaveData = () => {
    const users_share = selectedUsers.map((itm) => {
      const user = usersData.find((x) => x._id == itm.value);

      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
        };
      }
    });

    const payload = {
      selectedUsers: users_share,
      status: privacy,
      organizationName: user.profile.organizationId.name,
      webUrl,
      librarySourceType,
      text,
      name: name
        ? name
        : librarySourceType == 1
        ? uploadedFile.name
        : librarySourceType == 0
        ? webUrl.match(/https?:\/\/(?:www\.)?([^\/]+)/)[1]
        : `Custom text ${moment().format("MM/DD/YYYY")}`,
      isGenerateSummary,
    };

    const triviaForm = new FormData();

    if (uploadedFile) {
      triviaForm.append("document", uploadedFile.file);
    }

    triviaForm.append("payload", JSON.stringify(payload));

    const loaderApiData = {
      triviaForm: triviaForm,
      payload: payload,
      cb: onUploadSuccess,
      content:
        librarySourceType == 0
          ? webUrl
          : librarySourceType == 1
          ? uploadedFile.name
          : librarySourceType == 2
          ? text
          : "",
      contentType:
        librarySourceType == 0
          ? "LINK"
          : librarySourceType == 1
          ? "TEXT"
          : librarySourceType == 2
          ? "TEXT"
          : "",
    };

    setCreateLibraryLoader({
      loaderApiData,
      display: true,
      minimize: false,
    });

    onClose();
  };
  const uploadOptions = [
    { label: "Webpage", value: 0 },
    { label: "Upload File", value: 1 },
    { label: "Custom Text", value: 2 },
  ];
  return (
    <div>
      <Modal isOpen={open}>
        <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
          Upload Documents To Library
        </ModalHeader>
        <ModalBody className={"p-3 "}>
          <div className="my-3 px-5">
            <Label>Name (Optional)</Label>
            <Input
              placeholder="Pleae enter a name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="my-3 px-5">
            <div className="my-3">
              <Label>Data Source*</Label>
              <Select
                value={librarySourceType}
                onChange={(e) => {
                  if (e) {
                    setLibrarySourceType(e.value);
                  } else {
                    setLibrarySourceType(null);
                  }
                }}
                options={uploadOptions}
                placeholder="Select type of data upload..."
              />
            </div>
          </div>
          {librarySourceType === 1 ? (
            <div className="px-5">
              <div>
                <Label className={"mb-0"}>Upload Document</Label>
                <span className="font-13px ml-1">
                  (*Allowed files Pdf, Doc, Txt)
                </span>
              </div>
              <SupportedLanguagesText />
              {uploadedFile && renderUploadPreview()}
              <div className="singleTaskUploadModalBtn">
                <label
                  htmlFor="profile-pic-file-input"
                  style={{ marginBottom: "0px" }}
                >
                  <span
                    className={`actionsByStatus ${
                      isToolkit ? "upload_file_toolkit" : "singleTaskUpload"
                    }`}
                  >
                    <span className="flaticon-upload" />
                    Choose File
                  </span>
                </label>
                <input
                  id="profile-pic-file-input"
                  onChange={fileSelectedHandler}
                  type="file"
                  accept=".pdf,.doc,.docx,.txt"
                />
              </div>
            </div>
          ) : librarySourceType === 0 ? (
            <div className="px-5">
              <Label>Website Url*</Label>
              <Input
                onChange={(e) => {
                  setWebUrl(e.target.value);
                }}
                value={webUrl}
                placeholder="Enter website url"
              />
            </div>
          ) : librarySourceType === 2 ? (
            <div className="px-5">
              <textarea
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                }}
                rows={8}
                className="w-100"
                placeholder="Enter text for generating questions"
              />
            </div>
          ) : (
            ""
          )}

          <div className="mx-5">
            <div className="mt-3 trivvy_custom_template_form d-flex align-items-center">
              <Label className="mt-2">Document Privacy is</Label>

              <div
                style={{ display: "block", width: "200px" }}
                className="ml-2 pt-1"
              >
                <Select
                  value={privacy}
                  onChange={(val) => {
                    handleOptionChange(val);
                  }}
                  options={TRIVIA_LIB_PRIVACY_OPTIONS}
                  placeholder="Select Privacy"
                />
              </div>

              {privacy === "CUSTOM" ? (
                <FormGroup className={"mt40"} row>
                  <Col sm={9} md={9} lg={9}>
                    <FormGroup className="" row>
                      <Col sm={9} md={9} className="align-self-center px-0">
                        <Select
                          isMulti={true}
                          multi={true}
                          name="user-select"
                          placeholder={"Select users to share this quiz with"}
                          value={selectedUsers.length > 0 ? selectedUsers : ""}
                          isOpen={true}
                          options={usersList}
                          onChange={(itm) => setSelectedUsers(itm)}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </FormGroup>
              ) : null}
            </div>

            {minPlanLimitCheck(trivvyPlanType, "003") ? (
              <div className="my-3 trivvy_custom_template_form d-flex align-items-center">
                <CheckBox
                  className="mr-3"
                  onChange={(e) => {
                    setAlsoTranslate(e.target.checked);
                  }}
                />{" "}
                <Label className="mb-0">Also translate?</Label>
                
                  <div style={{ width: "300px", marginLeft: "20px" }}>
                    <Select
                      isMulti={true}
                      multi={true}
                      name="user-select"
                      placeholder={
                        alsoTranslate
                          ? "Select languages to translate"
                          : "(Please check to enable)"
                      }
                      value={selectedLanguages}
                      isOpen={true}
                      options={TRIVVY_LANGUAGES}
                      onChange={(values) => {
                        setSelectedLanguages(values);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      disabled={!alsoTranslate}
                    />
                  </div>
                
              </div>
            ) : (
              ""
            )}

            <div className="my-3">
              <Label>Generate Summary</Label>
              <CheckBox
                className="ml-3"
                checked={isGenerateSummary}
                onChange={(e) => {
                  setIsGenerateSummary(e.target.checked);
                }}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="mr-4 trivia-action-button-main"
            onClick={callApiToSaveData}
            // disabled={!validate()}
          >
            Create
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCreateLibraryLoader: (data) =>
      dispatch(actionCreators.setCreateLibraryLoader(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLoading(UploadLibraryModal, axios));
